export const isDebug = process.env.TRACKING_DEBUG || false;

export const DIMENSIONS_MAP = {
  prn: 'dimension41',
  accommodationType: 'dimension40',
  bookingType: 'dimension32',
  bookingPartner: 'dimension33',
};
